import { Provider } from "@angular/core";
import { InsServiceAbstract } from "./ins-service.abstract";
import { environment } from 'src/environments/environment';
import { InsWebSocketService } from "./strategies/ins-websocket.strategy";
import { InsRestService } from "./strategies/ins-rest.strategy";
import { InsMockService } from "./ins-mock.service";
import { ProfilService } from "../profil/profil.service";

const insServiceFactory = (
  profilSrv: ProfilService,
  insWebSocketSrv: InsWebSocketService,
  insRestSrv: InsRestService,
  insMockSrv: InsMockService
) => {
  const getStrategy = async () => {
    if (environment.mock) {
      return insMockSrv;
    }
    const useRest = await profilSrv.useEdcRestProxy();
    return useRest ? insRestSrv : insWebSocketSrv;
  };

  return new Proxy(insWebSocketSrv, {
    get(target, prop) {
      // Méthodes communes implémentées par InsServiceAbstract : indépendantes de la stratégie, appelées de manière synchrone
      if (prop !== 'constructor' && Object.prototype.hasOwnProperty.call(InsServiceAbstract.prototype, prop)) {
        return (InsServiceAbstract.prototype as any)[prop].bind(target);
      }

      // Pour les appels de méthodes
      if (typeof (target as any)[prop] === 'function') {
        return async (...args: any[]) => {
          const strategy = await getStrategy();
          return (strategy as any)[prop](...args);
        };
      }

      // Pour les propriétés synchrones
      const activeStrategy = environment.mock ? insMockSrv : insWebSocketSrv;
      return (activeStrategy as any)[prop];
    },
    set(target, prop, value) {
      // Synchronisation des propriétés sur l'ensemble des stratégies
      (insWebSocketSrv as any)[prop] = value;
      (insRestSrv as any)[prop] = value;
      (insMockSrv as any)[prop] = value;
      return true;
    }
  });
};

export const insServiceProvider: Provider[] = [
  {
    provide: InsServiceAbstract,
    useFactory: insServiceFactory,
    deps: [
      ProfilService,
      InsWebSocketService,
      InsRestService,
      InsMockService
    ]
  }
];
